import { Tooltip } from '@lokalise/louis'
import type { Integrations } from '@lokalise/translation-api-schemas'
import { AiModelIcon } from '../../../AiModelIcon/AiModelIcon'

import styles from './CardModel.module.css'

type CardModelProps = {
  integration: Integrations
}

export const CardModel = ({ integration }: CardModelProps) => {
  const tooltip = getTooltip(integration)

  return (
    <Tooltip tooltip={tooltip}>
      <div className={styles.container}>
        <AiModelIcon aria-label={tooltip} integration={integration} size="14px" role="img" />
      </div>
    </Tooltip>
  )
}

const getTooltip = (model: Integrations) => {
  switch (model) {
    case 'claude':
      return 'Claude'

    case 'gpt':
      return 'GPT'

    case 'gemini':
      return 'Gemini'

    default:
      return 'Routing'
  }
}
